import { DoggosActionTypes } from './types';
import { createAsyncAction } from '~lib/shared/redux/actions';
export const listOfficeDoggos = createAsyncAction(DoggosActionTypes.LIST_OFFICE_DOGGOS);
